import { IRootState } from '../../../store'
import { IAllPNNVOptionsState } from '../store/options.types'

export const getAllPNNVOptionsSelector = (state: IRootState): IAllPNNVOptionsState => state.options.allPNNVOptions
